import { Col, Row, Card } from "antd"
import { Outlet } from 'react-router-dom';



const ProductLayout = () => {



    return (
    <>
        <Card>
            {/* <Row> */}
            {/* <Col> */}
            <Outlet/>
            {/* </Col> */}
        {/* </Row> */}
        </Card>
    </>
  )
}

export default ProductLayout